export default {
  component: () => import('./page.vue'),
  path: '/unassigned',
  name: 'unassigned',
  meta: {
    title: '待反馈',
    auth: true,
  },
};
